// eslint-disable-next-line no-unused-vars
import { LeaderboardState, NavState } from '../types';

/**
 * @param {LeaderboardState} state - The Redux state.
 * @returns {NavState} The Draft Tracker State
 */
export const draftTrackerNavSelector = (state) =>
    state.draftTracker.leaderboard.nav;
